<script>
import Banner from '../components/banner'
export default {
    name: "about",
    data() {
        return {};
    },
    computed: {},
    components: {
        Banner
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="about">
        <Banner position="left center" :image="require('@/assets/images/about_banner.jpg')" :title="`About us`" :desc="`Learn More About Our Organization and\r\nthe Range of Services we Provide.`"/>
        <div class="wrapper layout_main">
            <p class="title">Our story</p>
            <p class="text">Located in Central London, Oxbridge Academy London is an innovative private higher education organization, accredited and partnered with top British universities and professional institutions worldwide. We offer a comprehensive range of internationally recognized, accredited, and affordable programs, from Professional Diplomas to Bachelor’s, Master’s degrees, leading to qualifications from some of the most respected universities and institutions globally. Our mission is to make high-quality, accredited education accessible to all, breaking down geographical, cultural, and economic barriers.</p>
            <div class="list flex">
                <div class="item">
                    <img src="@/assets/images/about_img_01.jpg" alt="" class="cover"/>
                    <p class="title">Our Vision</p>
                    <p class="text">Provide accessible, high-quality education to all by removing geographic, financial, and cultural barriers.</p>
                </div>
                <div class="item">
                    <img src="@/assets/images/about_img_02.jpg" alt="" class="cover"/>
                    <p class="title">Why Choose Us</p>
                    <p class="text">We are convinced that quality higher education is key to personal and career advancement. Through collaboration with renowned universities and awarding institutions, we strive to offer our learners top-tier, accredited, and internationally recognized qualifications.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.wrapper{
    padding: .8rem 0;
}
.title{
    font-size: .56rem;
    font-weight: bold;
    margin-bottom: .2rem;
    @media only screen and (max-width: 750px) {
        font-size: .32rem;
        margin-bottom: .5rem;
    }
}
.text{
    font-size: .2rem;
    color: #666;
    line-height: 1.8;
    text-align: justify;
    @media only screen and (max-width: 750px) {
        font-size: .24rem;
    }
}
.list{
    gap: 0 .2rem;
    margin-top: .8rem;
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        gap: .8rem 0;
    }
    .item{
        flex: 1;
        .cover{
            margin-bottom: .4rem;
        }
    }
}
</style>